export default "__VITE_ASSET__729d8864__"